import React from 'react'
import { useSelector } from 'react-redux';
import moment from "moment";

const PPA_MODE_LABELS = { online: "Online", offline: "Offline" };
const PAYMENT_STATUS_LABELS = { success: "Success", reject: "Reject", failure: "Failure" };

const DashboardFilter = ({openFilterModal, filterPayload, handleFilterRemove, isTierRemovalRequired=false}) => {
    const { department } = useSelector((state) => state.department);
  return (
    <div className='d-flex justify-content-between align-items-center'>
        <div className="p-2 d-flex gap-1 w-75">
            {
                filterPayload?.searchStr &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                {filterPayload?.searchStr} 
                <button type="button" onClick={() => handleFilterRemove('searchStr')} className="icon-close_circle_stroke fs-16px" aria-label="Remove search string filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
                
            </span>
            }
            {
                filterPayload?.tier &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                {filterPayload?.tier} 
                {
                    isTierRemovalRequired &&
                    <button type="button" onClick={() => handleFilterRemove('tier')} className="icon-close_circle_stroke fs-16px" aria-label="Remove tier filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
                }
            </span>
            }
            {
                filterPayload?.parent_department_id &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                Parent: {filterPayload?.parent_department_name || department?.find((e) => String(e.id) === String(filterPayload?.parent_department_id))?.name || filterPayload?.parent_department_id}
                <button type="button" onClick={() => handleFilterRemove('parent_department_id')} className="icon-close_circle_stroke fs-16px" aria-label="Remove parent department filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
            </span>
            }
            {
                filterPayload?.department_id &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                {department?.find((e) => e.id === filterPayload?.department_id)?.name} 
                <button type="button" onClick={() => handleFilterRemove('department_id')} className="icon-close_circle_stroke fs-16px" aria-label="Remove department filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
            </span>
            }
            {
                filterPayload?.district_id &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                District: {filterPayload?.district_name || filterPayload?.district_id}
                <button type="button" onClick={() => handleFilterRemove('district_id')} className="icon-close_circle_stroke fs-16px" aria-label="Remove district filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
            </span>
            }
            {
                filterPayload?.fromDate &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                {moment(filterPayload?.fromDate, 'YYYY-MM-DD').format('DD-MM-YYYY')} to {moment(filterPayload?.toDate, 'YYYY-MM-DD').format('DD-MM-YYYY')}
                <button type="button" onClick={() => handleFilterRemove('fromDate')} className="icon-close_circle_stroke fs-16px" aria-label="Remove from date filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
            </span>
            }
            {
                filterPayload?.ppa_mode &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                PPA Mode: {PPA_MODE_LABELS[filterPayload.ppa_mode] || filterPayload.ppa_mode}
                <button type="button" onClick={() => handleFilterRemove('ppa_mode')} className="icon-close_circle_stroke fs-16px" aria-label="Remove PPA mode filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
            </span>
            }
            {
                filterPayload?.payment_status &&
            <span className='fs-12px rounded-4 py-1 px-2 bg-white d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}>
                Payment status: {PAYMENT_STATUS_LABELS[filterPayload.payment_status] || filterPayload.payment_status}
                <button type="button" onClick={() => handleFilterRemove('payment_status')} className="icon-close_circle_stroke fs-16px" aria-label="Remove payment status filter" style={{ background: 'none', border: 'none', padding: 0 }}></button>
            </span>
            }
        </div>

        {/* <div className="edit">
            <span className='fs-12px rounded-4 cursor-pointer py-1 px-2 d-flex align-items-center gap-1' style={{border:"1px solid #DFDFDF"}}> 
            <i className='icon-published_with_changes fs-16px text-link'></i>
            <span className='text-link' onClick={()=>openFilterModal(true)} >Edit Filter</span> 
            
             </span>

        </div> */}
    </div>
  )
}

export default DashboardFilter
